export const JOBS_VIEW_GET         = "JOBS_VIEW_GET"
export const JOBS_VIEW_SET         = "JOBS_VIEW_SET"
